/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/prop-types */
import React from "react";

// import { css } from "@emotion/core";
import styled from "@emotion/styled";

// CSS
import "../../styles/audio-player.css";
import "react-h5-audio-player/lib/styles.css";
import css from "@emotion/css";
import { fonts, mediaQueries } from "../../configs/_configSite";
import ImgProduct from "../Images/Journal/ImgProductBackground";
import { LinkPurchaseExt } from "../Base/links/LinkPurchase";

const Container = styled.section`
  position: absolute;
  display: flex;
  align-items: center;
  jsutify-content: center;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;

const Wrapper = styled.section`
  position: relative;
  display: flex;
  z-index: 1;
  height: 400px;
  top: 0;
  bottom: 0;
  margin: auto;
  padding: 0 15px;
  box-sizing: border-box;
  max-width: ${mediaQueries.lg}px;

  @media (max-width: ${mediaQueries.lg}px) {
    max-width: ${mediaQueries.md}px;
  }
  @media (max-width: ${mediaQueries.md}px) {
    max-width: ${mediaQueries.sm}px;
  }
  @media (max-width: ${mediaQueries.sm}px) {
    max-width: 100%;
    width: 100%;
    flex-direction: column;
    height: 800px;
    top: 7.5vh;
  }
`;

const ImgContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  background: transparent;

  height: 350px;
  width: 500px;

  @media (max-width: ${mediaQueries.md}px) {
    height: 275px;
    width: 475px;
    margin: 0 auto;
  }

  @media (max-width: ${mediaQueries.sm}px) {
    height: 275px;
    width: 350px;
    margin: 0 auto;
  }

  @media (max-width: ${mediaQueries.xs}px) {
    height: 160px;
    width: 115px;
    margin: 0 auto;
    padding: 15px 30px 15px 15px;
  }
`;

const ProductContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  background: transparent;
  height: 100%;
  width: 70%;
  padding: 15px 60px;

  @media (max-width: ${mediaQueries.md}px) {
    height: 500px;
  }

  @media (max-width: ${mediaQueries.sm}px) {
    max-width: 100%;
    width: 100%;
    height: 400px;
  }
  @media (max-width: ${mediaQueries.xs}px) {
    height: auto;
    padding: 0 15px 30px;
  }
`;

const ProductTitle = styled.h1`
  position: relative;
  font-size: 34px;
  font-weight: 300;
  font-family: ${fonts.pentiary};
  color: black;
  @media (max-width: ${mediaQueries.xs}px) {
    margin: 0.5em 0;
  }
`;

const ProductDescription = styled.p`
  position: relative;
  font-family: Assistant;
  color: black;
  height: 175px;
  overflow: auto;
`;

const Price = styled.span`
  color: black;
  font-size: 28px;
  font-family: ${fonts.pentiary};
  margin-right: 30px;
`;

export default ({ data: { images, title, description, price, link } }) => {
  return (
    <Container>
      <Wrapper>
        <ImgContainer>{images}</ImgContainer>
        <ProductContainer>
          <ImgProduct />
          <ProductTitle>{title}</ProductTitle>
          <ProductDescription>{description}</ProductDescription>
          <div
            css={css`
              position: relative;
              text-align: right;
              @media (max-width: ${mediaQueries.xxs}px) {
                text-align: center;
                > * {
                  margin: 15px 0;
                }
              }
            `}
          >
            <Price>${price}</Price>
            <LinkPurchaseExt
              href={link}
              cssProp={css`
                display: inline-flex;
                @media (max-width: ${mediaQueries.xs}px) {
                  height: 50px;
                }
              `}
            >
              Purchase
            </LinkPurchaseExt>
          </div>
        </ProductContainer>
      </Wrapper>
    </Container>
  );
};
